import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import { useOrderContainersContext } from '../../../../Contexts/OrderContainersContext'
import { useDestinationsContext } from '../../../../Contexts/DestinationsContext'
import React, { useState } from 'react'

import { modes, paneModes } from '../../../../../../constants/orderWizard'
import { Popconfirm } from 'antd'
import { isTruckLoaded } from '../../../../util'
import { GraviButton } from '@gravitate-js/excalibrr'

export const NextButton = () => {
  const { setPaneMode, wizardOrder, fixUpLoadedOrderSupplyOption, setMode, orderEdited, isSaving, currentEntryMode } =
    useWizardMaster()
  const { compartments, haveCompartmentsChanged, checkTargetsForZero, removeEmptyTargets, productGroupsApi } =
    useOrderContainersContext()
  const { removeUnusedDestinations, setSelectedManifold, setSelectedTank } = useDestinationsContext()

  const truckIsLoaded = wizardOrder ? isTruckLoaded(wizardOrder.trip_status) : false
  const [showPopconfirm, setShowPopconfirm] = useState(false)
  const [popconfirmConfig, setPopconfirmConfig] = useState(firstTargetZeroConfig(setShowPopconfirm))
  const handleVisibleChange = (visible) => {
    if (!visible) {
      setShowPopconfirm(!visible)
    }
  }
  const warnBadSecondTarget = (problemTargets) => {
    setPopconfirmConfig(secondTargetZeroConfig(problemTargets, removeEmptyTargets, setShowPopconfirm))
    setShowPopconfirm(true)
  }
  const warnBadFirstTarget = () => {
    setPopconfirmConfig(firstTargetZeroConfig())
    setShowPopconfirm(true)
  }

  const saveProductOnClick = () => {
    const { hasStoreChanged, hasProductChanged, hasVolumeChanged } = haveCompartmentsChanged(
      wizardOrder && wizardOrder.compartments
    )

    if (currentEntryMode === 'by_product') {
      const destinationsFromGroups = removeUnusedDestinations(productGroupsApi.compartments)

      if (truckIsLoaded) {
        const payload = {
          order_id: wizardOrder.id,
          compartments: productGroupsApi.compartments,
          destinations: destinationsFromGroups.map((dest) => dest.store_number),
        }

        fixUpLoadedOrderSupplyOption(payload)
        return
      } else {
        setSelectedManifold(undefined)
        setSelectedTank(undefined)
        setPaneMode(paneModes.SUPPLYFILTERS)
        return
      }
    }

    const newDestinations = removeUnusedDestinations(compartments)

    if (!hasStoreChanged && !hasProductChanged && !hasVolumeChanged) {
      if (!orderEdited) {
        setMode(modes.VIEW)
      }
      setPaneMode(paneModes.TANKIMPACT)

      return
    } else if (truckIsLoaded) {
      const payload = {
        order_id: wizardOrder.id,
        compartments,
        destinations: newDestinations.map((dest) => dest.store_number),
      }
      fixUpLoadedOrderSupplyOption(payload)
      return
    }
    const { hasFirstTargetZero, hasSecondTargetZero, problemTargets } = checkTargetsForZero()
    if (hasSecondTargetZero) {
      warnBadSecondTarget(problemTargets)
    } else if (hasFirstTargetZero) {
      warnBadFirstTarget()
    } else {
      setPaneMode(paneModes.SUPPLYFILTERS)
    }
    setSelectedTank(undefined)
    setSelectedManifold(undefined)
  }

  return (
    <Popconfirm
      {...popconfirmConfig}
      onCancel={() => setShowPopconfirm(false)}
      open={showPopconfirm}
      onOpenChange={handleVisibleChange}
    >
      <GraviButton
        theme2
        buttonText='Save Products'
        data-cy='save-products-btn'
        onClick={() => saveProductOnClick()}
        loading={isSaving}
      />
    </Popconfirm>
  )
}
const firstTargetZeroConfig = (setShowPopconfirm) => {
  return {
    onConfirm: () => setShowPopconfirm(false),
    okText: 'OK',
    title: 'There are compartment(s) with 0 volume. Please fix the volume so the compartment is not empty.',
    cancelText: 'Close',
  }
}

const secondTargetZeroConfig = (problemTargets, removeEmptyTargets, setShowPopconfirm) => {
  return {
    onConfirm: () => {
      removeEmptyTargets(problemTargets)
      setShowPopconfirm(false)
    },
    okText: 'Remove',
    cancelText: 'Cancel',
    title:
      'There are multi-target compartment(s) with 0 volume. Click Remove to remove these destinations or Cancel to fix.',
  }
}
